import { __rest } from "tslib";
import * as React from 'react';
import { Form, FormGroup, ActionGroup, FormHelperText } from '../Form';
import { TextInput } from '../TextInput';
import { Button } from '../Button';
import { Checkbox } from '../Checkbox';
import { ValidatedOptions } from '../../helpers/constants';
export var LoginForm = function LoginForm(_a) {
  var _a$noAutoFocus = _a.noAutoFocus,
      noAutoFocus = _a$noAutoFocus === void 0 ? false : _a$noAutoFocus,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$showHelperText = _a.showHelperText,
      showHelperText = _a$showHelperText === void 0 ? false : _a$showHelperText,
      _a$helperText = _a.helperText,
      helperText = _a$helperText === void 0 ? null : _a$helperText,
      _a$helperTextIcon = _a.helperTextIcon,
      helperTextIcon = _a$helperTextIcon === void 0 ? null : _a$helperTextIcon,
      _a$usernameLabel = _a.usernameLabel,
      usernameLabel = _a$usernameLabel === void 0 ? 'Username' : _a$usernameLabel,
      _a$usernameValue = _a.usernameValue,
      usernameValue = _a$usernameValue === void 0 ? '' : _a$usernameValue,
      _a$onChangeUsername = _a.onChangeUsername,
      onChangeUsername = _a$onChangeUsername === void 0 ? function () {
    return undefined;
  } : _a$onChangeUsername,
      _a$isValidUsername = _a.isValidUsername,
      isValidUsername = _a$isValidUsername === void 0 ? true : _a$isValidUsername,
      _a$passwordLabel = _a.passwordLabel,
      passwordLabel = _a$passwordLabel === void 0 ? 'Password' : _a$passwordLabel,
      _a$passwordValue = _a.passwordValue,
      passwordValue = _a$passwordValue === void 0 ? '' : _a$passwordValue,
      _a$onChangePassword = _a.onChangePassword,
      onChangePassword = _a$onChangePassword === void 0 ? function () {
    return undefined;
  } : _a$onChangePassword,
      _a$isValidPassword = _a.isValidPassword,
      isValidPassword = _a$isValidPassword === void 0 ? true : _a$isValidPassword,
      _a$loginButtonLabel = _a.loginButtonLabel,
      loginButtonLabel = _a$loginButtonLabel === void 0 ? 'Log In' : _a$loginButtonLabel,
      _a$isLoginButtonDisab = _a.isLoginButtonDisabled,
      isLoginButtonDisabled = _a$isLoginButtonDisab === void 0 ? false : _a$isLoginButtonDisab,
      _a$onLoginButtonClick = _a.onLoginButtonClick,
      onLoginButtonClick = _a$onLoginButtonClick === void 0 ? function () {
    return undefined;
  } : _a$onLoginButtonClick,
      _a$rememberMeLabel = _a.rememberMeLabel,
      rememberMeLabel = _a$rememberMeLabel === void 0 ? '' : _a$rememberMeLabel,
      _a$isRememberMeChecke = _a.isRememberMeChecked,
      isRememberMeChecked = _a$isRememberMeChecke === void 0 ? false : _a$isRememberMeChecke,
      _a$onChangeRememberMe = _a.onChangeRememberMe,
      onChangeRememberMe = _a$onChangeRememberMe === void 0 ? function () {
    return undefined;
  } : _a$onChangeRememberMe,
      props = __rest(_a, ["noAutoFocus", "className", "showHelperText", "helperText", "helperTextIcon", "usernameLabel", "usernameValue", "onChangeUsername", "isValidUsername", "passwordLabel", "passwordValue", "onChangePassword", "isValidPassword", "loginButtonLabel", "isLoginButtonDisabled", "onLoginButtonClick", "rememberMeLabel", "isRememberMeChecked", "onChangeRememberMe"]);

  return React.createElement(Form, Object.assign({
    className: className
  }, props), React.createElement(FormHelperText, {
    isError: !isValidUsername || !isValidPassword,
    isHidden: !showHelperText,
    icon: helperTextIcon
  }, helperText), React.createElement(FormGroup, {
    label: usernameLabel,
    isRequired: true,
    validated: isValidUsername ? ValidatedOptions.default : ValidatedOptions.error,
    fieldId: "pf-login-username-id"
  }, React.createElement(TextInput, {
    autoFocus: !noAutoFocus,
    id: "pf-login-username-id",
    isRequired: true,
    validated: isValidUsername ? ValidatedOptions.default : ValidatedOptions.error,
    type: "text",
    name: "pf-login-username-id",
    value: usernameValue,
    onChange: onChangeUsername
  })), React.createElement(FormGroup, {
    label: passwordLabel,
    isRequired: true,
    validated: isValidPassword ? ValidatedOptions.default : ValidatedOptions.error,
    fieldId: "pf-login-password-id"
  }, React.createElement(TextInput, {
    isRequired: true,
    type: "password",
    id: "pf-login-password-id",
    name: "pf-login-password-id",
    validated: isValidPassword ? ValidatedOptions.default : ValidatedOptions.error,
    value: passwordValue,
    onChange: onChangePassword
  })), rememberMeLabel.length > 0 && React.createElement(FormGroup, {
    fieldId: "pf-login-remember-me-id"
  }, React.createElement(Checkbox, {
    id: "pf-login-remember-me-id",
    label: rememberMeLabel,
    isChecked: isRememberMeChecked,
    onChange: onChangeRememberMe
  })), React.createElement(ActionGroup, null, React.createElement(Button, {
    variant: "primary",
    type: "submit",
    onClick: onLoginButtonClick,
    isBlock: true,
    isDisabled: isLoginButtonDisabled
  }, loginButtonLabel)));
};